export default __webpack_public_path__ + "static/media/house.5779df46.svg";